var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.22081 12.9355C2.4568 11.5081 2.23123 9.85377 2.58524 8.27401C2.93925 6.69424 3.84925 5.29434 5.14931 4.32955C6.44937 3.36476 8.05288 2.89937 9.66745 3.01823C11.282 3.13708 12.8001 3.83228 13.9449 4.97704C15.0896 6.1218 15.7848 7.63988 15.9037 9.25445C16.0225 10.869 15.5571 12.4725 14.5923 13.7726C13.6276 15.0726 12.2277 15.9826 10.6479 16.3367C9.06813 16.6907 7.41376 16.4651 5.98643 15.7011L3.38393 16.4661C3.2547 16.504 3.11764 16.5065 2.98714 16.4732C2.85664 16.4399 2.73751 16.372 2.64227 16.2768C2.54704 16.1816 2.4792 16.0624 2.4459 15.9319C2.41259 15.8014 2.41504 15.6644 2.45299 15.5352L3.22081 12.9355Z",
    stroke: "#02b880",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5356 7.51172C16.6696 7.57337 17.7696 7.9201 18.7339 8.51982C19.6983 9.11954 20.4957 9.95286 21.0524 10.9426C21.6091 11.9324 21.9071 13.0466 21.9188 14.1822C21.9305 15.3177 21.6556 16.4379 21.1194 17.4389L21.8844 20.0414C21.9223 20.1706 21.9248 20.3077 21.8915 20.4382C21.8582 20.5687 21.7903 20.6878 21.6951 20.7831C21.5999 20.8783 21.4807 20.9461 21.3502 20.9794C21.2197 21.0127 21.0827 21.0103 20.9534 20.9723L18.3538 20.2045C17.495 20.6638 16.5471 20.9319 15.575 20.9906C14.6029 21.0492 13.6296 20.8969 12.7219 20.5442C11.8141 20.1915 10.9934 19.6467 10.3159 18.9471C9.63844 18.2475 9.12025 17.4097 8.79688 16.4911",
    stroke: "#02b880",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.3ce9e0e899f0b8751d2d0a86e4963230.svg";
export { ForwardRef as ReactComponent };